import React, { useContext, useEffect, useState } from "react";
import { loadStates } from "../../apis";

const StatesContext = React.createContext([]);

const StatesProvider = (props) => {
  const [states, setStates] = useState([]);

  useEffect(() => {
    (async () => {
      setStates(await loadStates());
    })();
  }, []);

  return (
    <StatesContext.Provider
      {...props}
      value={states}
    />
  );
};

export const useStates = () => {
  const context = useContext(StatesContext);

  if (context === undefined) {
    throw new Error("useStates must be used within a StatesProvider");
  }

  return context;
};

export default StatesProvider;
